<template>
  <div class="carbine-container">
<v-tabs
      v-model="tab"
      grow
      light
      color="#e7511e"
    >
      <v-tabs-slider></v-tabs-slider>
      <v-tab href="#tab-Projects">
        Projects
      </v-tab>

      <v-tab href="#tab-Proposals">
        Proposals
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item
        v-for="(table, i) in tables"
        :key="i"
        :value="'tab-' + table.title"
      >
        <v-card flat>
          <v-card-title>
            <!-- {{table.title}}
            <v-spacer></v-spacer> -->
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>          
          <v-data-table
            v-if="table.data"
            :headers="headers"
            :items="table.data"
            :items-per-page="5"
            :search="search"
            class="elevation-1"
          ></v-data-table>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import AdministrationApi from '@/services/AdministrationApi';
import CommonRules from 'src/common-rules.js';
export default {
  data () {
    return {
      rules: CommonRules,
      tab: null,
      search: '',
      tables: [
        {
          title: 'Projects',
          data: null
        },
        {
          title: 'Proposals',
          data: null
        }
      ],
      headers: [
        { text: 'Job', value: 'job_id' },
        { text: 'Client', value: 'client' },
        { text: 'Title', value: 'title' }
      ]      
    }
  },
  mounted() {
    AdministrationApi.getProjects().then((response)=>{
      this.tables[0].data = response.data.projects;
    })
    .catch(error => {
      if (error.response) {
        if (error.response.status === 403) {
          this.rules.resourceForbidden(error, this);
        } else {
          console.log(error.response.data);
        }
      }
    });
    AdministrationApi.getProposals().then((response)=>{
      this.tables[1].data = response.data.proposals;
    })
    .catch(error => {
      if (error.response) {
        if (error.response.status === 403) {
          this.rules.resourceForbidden(error, this);
        } else {
          console.log(error.response.data);
        }
      }
    });
  }
}
</script>

<style scoped>
  .carbine-container{
    width: 96%;
    margin: 0 auto;
    padding: 20px;
  }
</style>